import React, { useEffect, useRef, useState } from 'react';

import { formatNumericValue, getInputValue, parseInputValue } from '../utils';

import DisplayCost from './DisplayCost';

const PackagingSection = ({ data = {}, totalCost = 0, onChange, isEditable = true, onFieldChange }) => {
	const [packaging, setPackaging] = useState({
		packaging_price_breakdown: [],
		additionalPackagingCost: 0
	});
	const isInitialMount = useRef(true);
	const prevDataRef = useRef(null);

	useEffect(() => {
		const dataString = JSON.stringify(data);
		const prevDataString = JSON.stringify(prevDataRef.current);

		if (dataString === prevDataString) {
			return;
		}

		if (data && Object.keys(data).length > 0) {
			setPackaging({
				packaging_price_breakdown:
					data.packaging_price_breakdown?.map((item) => ({
						...item,
						item_price_usd: formatNumericValue(item.item_price_usd)
					})) || [],
				additionalPackagingCost: formatNumericValue(data.additionalPackagingCost)
			});
		}

		prevDataRef.current = data;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [data]);

	const transformToApiFormat = (updatedPackaging) => {
		return {
			packaging_price_breakdown:
				updatedPackaging.packaging_price_breakdown?.map((item) => ({
					...item,
					item_price_usd: formatNumericValue(item.item_price_usd)
				})) || [],
			additionalPackagingCost: formatNumericValue(updatedPackaging.additionalPackagingCost)
		};
	};

	const notifyChange = (updatedPackaging) => {
		if (onChange && !isInitialMount.current) {
			onChange(transformToApiFormat(updatedPackaging));
		}
	};

	const handleInputChange = (field, value) => {
		const updatedValue = parseInputValue(value);
		if (onFieldChange) onFieldChange(field);
		const updatedPackaging = { ...packaging, [field]: updatedValue };
		setPackaging(updatedPackaging);
		notifyChange(updatedPackaging);
	};

	const handlePackagingInputChange = (value, idx) => {
		const clonePackaging = { ...packaging };

		let currentItem = clonePackaging?.packaging_price_breakdown?.[idx] || undefined;
		if (!currentItem) return;
		if (onFieldChange) onFieldChange(currentItem?.item_name);
		currentItem.item_price_usd = parseInputValue(value);
		setPackaging(clonePackaging);
		notifyChange(clonePackaging);
	};

	return (
		<div className="single-table trims-content mt-5">
			<div className="d-flex justify-content-between mb-2">
				<p>Packaging Cost Metrics</p>
			</div>
			<div className="row">
				{packaging?.packaging_price_breakdown?.map((item, idx) => {
					let value = getInputValue(item?.item_price_usd);
					return (
						<div className="col-md-6 col-sm-12 mb-2" key={`packaging_item_${idx}`}>
							<p className="regular-12 gray_dark_02 pb-1">{item?.item_name} ($)</p>
							<input
								type="number"
								step="0.01"
								value={value}
								// onChange={(e) => handleInputChange('cartonAverageQuality', e.target.value)}
								onChange={(e) => handlePackagingInputChange(e.target.value, idx)}
								readOnly={!isEditable}
							/>
						</div>
					);
				})}
				<div className="col-md-6 col-sm-12 mb-2">
					<p className="regular-12 gray_dark_02 pb-1">Additional Packaging Cost (%)</p>
					<input
						type="number"
						step="0.01"
						value={getInputValue(packaging.additionalPackagingCost)}
						onChange={(e) => handleInputChange('additionalPackagingCost', e.target.value)}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Packaging Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">
						<DisplayCost totalCost={totalCost} />
					</p>
				</div>
			</div>
		</div>
	);
};

export default PackagingSection;
